import { differenceInMonths, differenceInYears, isValid } from 'date-fns';

export function getYearsAndMonthsFromNow(date?: Date) {
  if (!date) {
    return { years: -1, months: -1 };
  }

  const now = new Date();

  const years = Math.max(differenceInYears(now, date), 0);
  const months = Math.max(differenceInMonths(now, date) - years * 12, 0);

  return { years, months };
}

export function formatDate(
  locale: string,
  date: Date,
  options?: Intl.DateTimeFormatOptions
) {
  if (!isValid(date)) return '';

  const { timeZone: defaultTimeZone } = Intl.DateTimeFormat().resolvedOptions();

  return new Intl.DateTimeFormat(locale, {
    timeZone: defaultTimeZone,
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    ...options,
  }).format(date);
}

export function formatDateInParts(
  date: Date,
  locale: string,
  options?: Intl.DateTimeFormatOptions
) {
  const formatter = new Intl.DateTimeFormat(locale, options);

  const parts = formatter.formatToParts(date);

  return parts.reduce(
    (acc, part) => {
      if (
        ['month', 'day', 'year', 'hour', 'minute', 'dayPeriod'].includes(
          part.type
        )
      ) {
        const { value } = part;
        acc[part.type as keyof typeof acc] = value;
      }
      return acc;
    },
    { month: '', day: '', year: '', hour: '', minute: '', dayPeriod: '' }
  );
}

export function isDateInRange(start: string, end: string) {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const currentDate = new Date();

  return currentDate >= startDate && currentDate <= endDate;
}
